import { useDeployBais } from '@sunstone/api-client/hooks';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@sunstone/ui';
import { toast } from 'sonner';
import { useAuthToken } from '@/features/auth';

interface DeployBaisDialogProps {
  workspaceId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeployBaisDialog({ workspaceId, open, onOpenChange }: DeployBaisDialogProps) {
  const { token } = useAuthToken();
  const deployBais = useDeployBais(token);

  function handleDeploy() {
    deployBais.mutate(
      { workspaceId, releaseId: '' },
      {
        onSuccess: () => {
          toast.success('CSAI deploy dispatched.');
        },
        onError: (err) => toast.error(err.message ?? 'Failed to dispatch CSAI deploy.'),
      },
    );
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deploy CSAI</AlertDialogTitle>
          <AlertDialogDescription>
            Deploy the CSAI components to this workspace using the current release's installer and
            service branches.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDeploy}>Deploy</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
